"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.summarySchema = void 0;
const zod_1 = require("zod");
const platform_1 = require("./platform");
const baseSummary = zod_1.z.object({
    userId: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
});
const weeklySummary = zod_1.z.object({
    kind: zod_1.z.literal("weekly"),
    content: zod_1.z
        .object({
        hasAvailableData: zod_1.z.boolean(),
        interval: zod_1.z.object({
            start: zod_1.z.date(),
            end: zod_1.z.date(),
        }),
        conversationDurationTopPercentile: zod_1.z.number().nullable(),
        currentStreak: zod_1.z.number(),
        currentWeek: zod_1.z.object({
            usageByDay: zod_1.z.object({
                sat: zod_1.z.number(),
                sun: zod_1.z.number(),
                mon: zod_1.z.number(),
                tue: zod_1.z.number(),
                wed: zod_1.z.number(),
                thu: zod_1.z.number(),
                fri: zod_1.z.number(),
            }),
            totalUsageInHours: zod_1.z.number(),
            totalUsageDifferencePercentage: zod_1.z.number().nullable(),
            usageDays: zod_1.z.number(),
        }),
        finishedConversationCount: zod_1.z.object({
            total: zod_1.z.number(),
            differencePercentage: zod_1.z.number().nullable(),
        }),
        finishedUserActivityCount: zod_1.z.object({
            total: zod_1.z.number(),
            differencePercentage: zod_1.z.number().nullable(),
        }),
        usedPlatforms: zod_1.z.array(platform_1.platformSchema),
        mostUsedDay: zod_1.z.object({
            day: zod_1.z.enum(["sat", "sun", "mon", "tue", "wed", "thu", "fri"]),
            period: zod_1.z.enum(["morning", "afternoon", "evening", "night"]),
        }),
    })
        .or(zod_1.z.object({
        hasAvailableData: zod_1.z.boolean(),
    })),
});
exports.summarySchema = zod_1.z
    .discriminatedUnion("kind", [weeklySummary])
    .and(baseSummary);
//# sourceMappingURL=summary.js.map